exports = module.exports = require("./../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".carousel{overflow:hidden;white-space:nowrap;width:100%}.carousel .dots{list-style:none;position:relative}.carousel .dots li{float:left}.carousel .dots .active{text-decoration:underline}.carousel .step{position:fixed;z-index:100;top:50%;width:50;height:50;background:#fff;padding:10px;border:1px dashed #fece3c;cursor:pointer}.carousel .step:hover{background:#fece3c}.carousel .step.previous{left:0;border-radius:0 10px 10px 0;border-left:none}.carousel .step.previous:after{content:' < '}.carousel .step.next{right:0;border-radius:10px 0 0 10px;border-right:none}.carousel .step.next:after{content:' > '}.carousel .panes{list-style:none;position:relative;padding:10px;margin:0}.carousel .panes>li{position:relative;float:left}.carousel .panes .pane{overflow:hidden}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./css/carousel.css
// module id = 97
// module chunks = 0